<template>
	<div class="deck" :class="{ editing }">
		<div class="title" @click="toggle()">Your collection</div>

		<div class="cards" v-hammer:panstart="panstart" v-hammer:pan.horizontal="pan" v-hammer:panend="panend" @mousewheel="wheel">
			<div class="cards-content" ref="cards" :class="{ panning }" :style="{ transform: 'translateX(' + scroll_x + 'px)' }">
				<div v-for="card in game.deck" class="card-wrap" :class="{ added: fight.player && fight.player.cards.includes(card) }" :key="card.id" v-hammer:tap="() => select_card(card)">
					<card :card="card" />
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from '@/components/game/card'
import Sounds from '@/js/sounds'

let inital_x = 0

export default {
	name: 'deck',
	data() {
		return {
			scroll_x: 0,
			panning: false
		}
	},
	props: {
		editing: { default: false }
	},
	computed: {
		...mapGetters([ 'game', 'fight' ]),
	},
	methods: {
		scroll(x) {
			const win_width = this.$el.clientWidth
			const cards_width = this.$refs.cards.clientWidth
			if (cards_width > win_width) {
				if (x > 0) {
					x = 0 
				} else {
					if (x - win_width < -cards_width) x = win_width - cards_width - 32
				}
				this.scroll_x = x
			}
		},
		wheel(e) {
			this.panning = false
			this.scroll(this.scroll_x - e.deltaY)
			setTimeout(() => {
				if (this.scroll_x > 0) this.scroll(0)
				inital_x = this.scroll_x
			}, 250)
		},
		pan(e) {
			this.scroll(inital_x + e.deltaX)
		},
		panstart(e) {
			this.panning = true
			this.scroll(e.deltaX)
		},
		panend(e) {
			this.panning = false
			// if (this.scroll_x > 0) this.scroll_x = 0
			// const win_width = this.$el.clientWidth
			// const cards_width = this.$refs.cards.clientWidth
			// if (cards_width > win_width) {
			// 	const max = (cards_width - this.scroll_x) - win_width
			// 	if (max > win_width) this.scroll(win_width - cards_width - 32)
			// } else
			// this.scroll(0)
			inital_x = this.scroll_x
		},
		toggle() {
			this.$emit('toggle')
		},
		select_card(card) {
			Sounds.play('button')
			this.$store.dispatch('select_card', { card })
		}
	},
	components: { Card }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'


.deck
	position absolute
	left 0
	right 0
	bottom 0
	height 272px
	width 100%
	transition 0.25s easeOutQuart
	transform translateY(250px)
	&.editing
		// box-shadow 0 0 0 2px light
		background-color darken(dark, 25%)
		transform translateY(136px)
	.title
		position absolute
		left 24px
		top -19px
		height 40px
		padding 0 32px
		background-color light
		line-height (@height + 4px)
		color dark
		text-transform uppercase
		text-align center
		white-space nowrap
		font-weight 700
		cursor pointer
		z-index 2
		&:hover
			background-color darken(light, 10%)
		&:active
			background-color darken(light, 10%)
			transform translateY(2px)
	.cards
		width 100%
		overflow auto
		padding 40px 16px 16px 16px
		.cards-content
			height 100%
			width max-content
			flex flex-start flex-start
			transition transform 0.25s easeOutQuart
			&.panning
				transition none
			.card-wrap
				display inline-block
				margin 8px
				cursor pointer
				transition 0.15s easeOutQuart
				&:hover
					transform translateY(-8px)
				&.added
					opacity 0.1
					transform translateY(4px)
					&:hover
						opacity 0.2
						transform none


</style>
